__turbopack_context__.v({
  "container": "BByNHW_container",
  "context": "BByNHW_context",
  "logo": "BByNHW_logo",
  "quote": "BByNHW_quote",
  "stamp": "BByNHW_stamp",
});
